import { reactive } from 'vue'

export const geoMaps = reactive({
    coordenates: '',
    })